import { IObjectTranslatable, HtmlColorCodeTranslator } from ".";
import { ICircleItemBean, ITypeDefinable, BeanTypes } from "../beans/items";
import { IItem, CircleItem } from "../../../../domain/document/items";

import {
  Point,
  Size,
  Rectangle,
  LineStyle,
  Color,
  PaintStyle,
} from "../../../../domain/drawing";

export class CircleItemTranslator implements IObjectTranslatable {
  toItem(item: ITypeDefinable, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    const bean = item as ICircleItemBean;
    const result = new CircleItem();
    result.privateId = (bean as any).privateId; // フロントエンド独自パラメータ.
    result.uniqueKey = bean.uniqueKey;
    result.id = bean.id;
    result.sectionObjectUid = bean.sectionObjectUid;
    result.isEditable = !!bean.isAdditional; // 追加オブジェクトのみ編集可能とする
    result.isAdditional = !!bean.isAdditional;
    result.isDeleted = !!bean.isDeleted;
    result.isVisible = !!bean.isVisible;
    result.typeDetail = bean.typeDetail;
    result.viewTitle = bean.viewTitle;
    result.printBehavior.shouldPrint = !!bean.printVisible;
    result.printBehavior.shouldPreview = !!bean.previewVisible;
    result.geometry.rectangle = new Rectangle(new Point(bean.x, bean.y), new Size(bean.width, bean.height));
    result.lineStyle = new LineStyle(new Color(bean.color), bean.state, bean.thickness);
    result.paintStyle = new PaintStyle(new Color(bean.backColor), bean.textureState, bean.additionalTextureState);
    return result;
  }

  toBean(item: IItem): ITypeDefinable {
    const target = item as CircleItem;
    const bean: ICircleItemBean = {
      type: BeanTypes.Ellipse,
      uniqueKey: target.uniqueKey,
      id: target.id,
      sectionObjectUid: target.sectionObjectUid,
      isVisible: target.isVisible,
      printVisible: target.printBehavior.shouldPrint,
      previewVisible: target.printBehavior.shouldPreview,
      x: Math.floor(target.geometry.rectangle.x),
      y: Math.floor(target.geometry.rectangle.y),
      width: Math.floor(target.geometry.rectangle.width),
      height: Math.floor(target.geometry.rectangle.height),
      color: HtmlColorCodeTranslator.fromColor(target.lineStyle.color),
      state: target.lineStyle.kind,
      thickness: target.lineStyle.width,
      backColor: HtmlColorCodeTranslator.fromColor(target.paintStyle.color),
      textureState: target.paintStyle.kind,
      additionalTextureState: target.paintStyle.additionalTextureKind,
      isAdditional: target.isAdditional,
      isDeleted: target.isDeleted,
      typeDetail: target.typeDetail,
      viewTitle: target.viewTitle,
    };
    return bean;
  }
}
